// Shared helper to surface "carry forward" fabric reference values (Main/Lining/Contrast
// Fabric ID) from the most recently added product in an order, so staff customizing a 2nd/3rd
// piece of a suit (e.g. Trouser after Jacket) can quickly copy the same fabric details instead
// of retyping them.

export const FABRIC_SELECTOR_LABELS = {
  main: 'Main Fabric ID',
  lining: 'Lining Fabric ID',
  contrast: 'Contrast Fabric ID',
  button: 'Button Code',
};

const FABRIC_SELECTOR_ORDER = ['main', 'lining', 'contrast', 'button'];

const normalizeSelectorType = (type) => {
  const normalized = String(type || '').toLowerCase().replace('_fabric', '').trim();
  return FABRIC_SELECTOR_ORDER.includes(normalized) ? normalized : null;
};

/**
 * @param {Array} lineItems - line items already added to the order (each expected to carry
 *   `customizations` and `snapshot_customization_schema` as saved by the customization flow).
 * @param {string|null} excludeId - id of the line item currently being edited/duplicated, if any.
 */
export const getFabricReferencePanel = (lineItems = [], excludeId = null) => {
  const candidates = (lineItems || []).filter(
    (item) => item && item.id !== excludeId && item.line_item_id !== excludeId
  );

  if (!candidates.length) {
    return { sourceProductName: null, items: [] };
  }

  const lastItem = candidates[candidates.length - 1];
  const schema = lastItem.snapshot_customization_schema;
  const allOptions = (schema?.categories || []).flatMap((c) => c.options || []);
  const seenTypes = new Set();
  const items = [];

  (lastItem.customizations || []).forEach((c) => {
    const option = allOptions.find((o) => o.option_id === c.option_id);
    if (!option || !option.is_fabric_selector || !c.selected_value) return;
    const normalized = normalizeSelectorType(option.fabric_selector_type);
    if (!normalized || seenTypes.has(normalized)) return;
    seenTypes.add(normalized);
    items.push({ key: normalized, label: FABRIC_SELECTOR_LABELS[normalized], value: c.selected_value });
  });

  items.sort((a, b) => FABRIC_SELECTOR_ORDER.indexOf(a.key) - FABRIC_SELECTOR_ORDER.indexOf(b.key));

  return { sourceProductName: lastItem.product_name, items };
};
